import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { AttachmentCollection } from '../index'

export const setupAttachmentReplication = (
  collection: AttachmentCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'attachments',
    displayName: 'Attachment',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      entityType: doc.entityType,
      entityId: doc.entityId,
      fileName: doc.fileName,
      fileType: doc.fileType,
      fileSizeBytes: doc.fileSizeBytes,
      storageKey: doc.storageKey,
      fileUrl: doc.fileUrl,
      description: doc.description,
      uploadStatus: doc.uploadStatus,
      isDeleted: doc.isDeleted || false,
      createdByName: doc.createdByName,
      createdByEmail: doc.createdByEmail,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      entityType: state.entityType,
      entityId: state.entityId,
      fileName: state.fileName,
      fileType: state.fileType,
      fileSizeBytes: state.fileSizeBytes,
      storageKey: state.storageKey,
      fileUrl: state.fileUrl,
      description: state.description,
      uploadStatus: state.uploadStatus,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
